/**
 * Record Flow for managers: /portal/record-flow.
 *
 * The same page as the admin console's, reading /record-flow instead of
 * /admin/record-flow. The server decides who may open it (RECORD_FLOW_VIEW and
 * PHI access); this page only points the views at the other base and gives the
 * page the workspace bar the portal workspaces carry.
 */
import React, { useLayoutEffect } from 'react';
import WorkspaceMenu from '../../../components/WorkspaceMenu';
import RecordFlow from './RecordFlow';
import { PORTAL_FLOW_BASE, setFlowBase } from './flowApi';

export default function RecordFlowPortal() {
  // Layout effects of the whole tree run before any passive (load) effect, so no view reads the admin base first.
  useLayoutEffect(() => {
    const previous = setFlowBase(PORTAL_FLOW_BASE);
    return () => { setFlowBase(previous); };
  }, []);
  return (
    <div>
      <WorkspaceMenu current="RECORD_FLOW" />
      <div className="mx-auto max-w-[1400px] px-4 py-4">
        <RecordFlow />
      </div>
    </div>
  );
}
